import enTranslationMessages from './translations/en.json';
import esTranslationMessages from './translations/es.json';
import zhTranslationMessages from './translations/zh.json';

import { APP_NAME } from './constants/env';
import brandConfig from './constants/brandConfig';

export const DEFAULT_LOCALE = 'en';
export const appLocales = ['en', 'es', 'zh'];

const insertAppConsts = string => {
  const consts = {
    appName: APP_NAME,
    brandName: brandConfig.name,
  };

  return Object.keys(consts).reduce((updatedString, name) => {
    const re = new RegExp(`{${name}}`, 'g');

    return updatedString.replace(re, consts[name]);
  }, string);
};

const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages)
      : {};

  return Object.keys(messages).reduce((formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key];

    return Object.assign(formattedMessages, {
      [key]: insertAppConsts(formattedMessage),
    });
  }, {});
};

export const getTranslationMessages = () => ({
  en: formatTranslationMessages('en', enTranslationMessages),
  es: formatTranslationMessages('es', esTranslationMessages),
  zh: formatTranslationMessages('zh', zhTranslationMessages),
});



// WEBPACK FOOTER //
// ./src/i18n.js